export default __webpack_public_path__ + "static/media/background-image-5.aa8c5cd5.jpg";